const baseUrl = "/v1/admin/customer";

export const apiUrls = {
  list: `${baseUrl}/access-code/compnies`,
  create: `${baseUrl}/create`,
  update: (id: number): string => `${baseUrl}/${id}/update`,
  delete: (id: number): string => `${baseUrl}/${id}/delete`,
  details: (id: number): string => `${baseUrl}/${id}/details`,
  changeStatus: (id: number): string => `${baseUrl}/${id}/change-status`,
  export: (id: number): string => `${baseUrl}/${id}/export`,
};
